export const CATEGORY = `
_id
name
description
`;
